import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';

// Firebase production config
const config = {
  apiKey: 'AIzaSyDZbrhEKCgtuQQ7vyDbwsWi-vsacUEVcC0',
  authDomain: 'lessons-learned-oil-field.firebaseapp.com',
  databaseURL: 'https://lessons-learned-oil-field.firebaseio.com',
  projectId: 'lessons-learned-oil-field',
  storageBucket: 'lessons-learned-oil-field.appspot.com',
  messagingSenderId: '758020347038',
  appId: '1:758020347038:web:c2c7a023dd6d438746178f',
};

// Firebase dev config
const devConfig = {
  apiKey: "AIzaSyAQ8XvpfGwUphlm1uMr6mtLCKX7KLALPG8",
  authDomain: "lessons-test-db.firebaseapp.com",
  databaseURL: "https://lessons-test-db.firebaseio.com",
  projectId: "lessons-test-db",
  storageBucket: "lessons-test-db.appspot.com",
  messagingSenderId: "718909840732",
  appId: "1:718909840732:web:c874f8a88eb956a039f599",
  measurementId: "G-9B286Y33K5"
}

// firebase.initializeApp(devConfig);
firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const firebaseFunctions = firebase.functions();

const { currentUser } = auth;

// date issue fix according to firebase
// const settings = {
//   timestampsInSnapshots: true
// }
// db.settings(settings)

// firebase collections
const companiesCollection = db.collection('companies');
const safetyCollection = db.collection('safety');
const drillingCollection = db.collection('oilfieldLessons/aars/drilling');
const wellControlCollection = db.collection('wellControl');

export {
  db,
  auth,
  currentUser,
  companiesCollection,
  firebaseFunctions,
  safetyCollection,
  drillingCollection,
  wellControlCollection,
};
